const state = {
  strWebSiteId: "0ce5ec1a0ae0463f8e4de81ae39616c2",
}

export default state
